export const NEW_PROJECT_PAGE = 'new-project';
export const PROJECTS_PAGE = 'portfolio';
